import { render, staticRenderFns } from "./EricSearchWidget.vue?vue&type=template&id=abf2dab8"
import script from "./EricSearchWidget.vue?vue&type=script&lang=js"
export * from "./EricSearchWidget.vue?vue&type=script&lang=js"
import style0 from "./EricSearchWidget.vue?vue&type=style&index=0&id=abf2dab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports